import React from 'react';
import { Calendar, Users, Crown, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

const features = [
  {
    name: 'Opportunities Shared Monthly',
    description: 'Get curated lists of scholarships, internships, and events delivered to you.',
    icon: Calendar,
  },
  {
    name: 'Trusted Students Community',
    description: 'Connect with ambitious students from top universities across Bangladesh.',
    icon: Users,
  },
  {
    name: 'Exclusive VIP Portal Access',
    description: 'Unlock premium content, mentorship sessions, and priority event registration.',
    icon: Crown,
  },
  {
    name: 'Fast Support Response',
    description: 'Our dedicated team is always ready to help you navigate your career path.',
    icon: Clock,
  },
];

const Features = () => {
  return (
    <div className="py-12 bg-section-gradient">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-base text-vibrant-red font-semibold tracking-wide uppercase">What We Offer</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl">
            Everything you need to succeed
          </p>
          <p className="mt-4 max-w-2xl text-xl text-medium-gray lg:mx-auto">
            We provide the tools, resources, and community support to help you excel in your extracurricular and academic life.
          </p>
        </div>

        <div className="mt-10">
          <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
            {features.map((feature, index) => (
              <motion.div 
                key={feature.name} 
                className="relative"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-button-gradient text-white shadow-glow">
                    <feature.icon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-white">{feature.name}</p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-medium-gray">{feature.description}</dd>
              </motion.div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
};

export default Features;
